import { Box, Chip, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import React from "react";

import { ProductCard } from "../../types/productPlane";
import { moreCapabilities } from "./productFields";

interface CapabilityChipsProps {
  product: ProductCard;
}

// The capabilities a card names, as small accent chips, then the number of
// further ones. Renders nothing for a product with none.
const CapabilityChips: React.FC<CapabilityChipsProps> = ({ product }) => {
  const more = moreCapabilities(product);
  if (product.capabilities.length === 0 && !more) {
    return null;
  }

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 0.75 }}>
      {product.capabilities.map((capability) => (
        <Chip
          key={capability.id}
          label={capability.name}
          size="small"
          sx={{
            height: 22,
            maxWidth: "100%",
            fontSize: "0.75rem",
            color: "link.main",
            backgroundColor: (theme) => alpha(theme.palette.link.main, 0.12),
          }}
        />
      ))}
      {more && (
        <Typography variant="caption" color="text.secondary">
          {more}
        </Typography>
      )}
    </Box>
  );
};

export default CapabilityChips;
